module.exports = __webpack_public_path__ + "img/goods3.168d0852.png";